import { render } from "./Hello.vue?vue&type=template&id=1669acaf&scoped=true"
import script from "./Hello.vue?vue&type=script&lang=js"
export * from "./Hello.vue?vue&type=script&lang=js"

import "./Hello.vue?vue&type=style&index=0&id=1669acaf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1669acaf"]])

export default __exports__